module.exports = "/img/6.438f90.webp";